import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import DirectoryTable from '../../ui/DirectoryTable';
import { MapContainer, Marker, TileLayer, useMap, useMapEvents } from 'react-leaflet';
import { Box } from '@mui/material';
import MarkerClusterGroup from "@changey/react-leaflet-markercluster";

// import MarkerClusterGroup from 'react-leaflet-cluster'
// import { MarkerClusterGroup } from 'leaflet';
// import MarkerClusterGroup from 'react-leaflet-markercluster';
// import geocoder from 'geocoder'
import { GeoSearchControl, OpenStreetMapProvider, SearchControl } from "leaflet-geosearch";

import MarkerIcon from "../../../../../images/property-location-icon.png"

import "./SafeApMapPopup.scss"

import L from 'leaflet'


const customIcon = new L.Icon({
    iconUrl: MarkerIcon,
    iconSize: new L.Point(25, 32)
})

const SafeApMapPopup = ({ showPopup, handleCloseModal, tableData }) => {

    // console.log(tableData)

    return (

        <Modal
            show={showPopup}
            size="xl"
            // backdrop="static"
            keyboard={false}
            onHide={handleCloseModal}
            // onBackdropClick={handleCloseModal}
            centered
            scrollable
            style={{ zIndex: 10000 }}
        >
            <Modal.Header>
                <h5>
                    SafeAp Directory
                </h5>
            </Modal.Header>
            <Modal.Body>
                {
                    !tableData || tableData.length === 0 ?
                        "An Error occured" :
                        <MapAndTableComponent tableData={tableData} />

                }

            </Modal.Body>
        </Modal>

    );
};

const MapAndTableComponent = ({ tableData }) => {
    const [visibleData, setVisibleData] = useState([])

    return (<Box>

        <MapContainer
            style={{ height: "400px" }}
            center={[51.0456064, -114.057541]}
            zoom={4}
            scrollWheelZoom={true}
        >

            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <MapSearch />
            <MarkerClusterComponent tableData={tableData} setVisibleData={setVisibleData} />
            {/* <Marker
                position={[tableData[0].addressCordinates[0].latitude, tableData[0].addressCordinates[0].longitude]}
                title={tableData[0].addressCordinates[0].formattedAddress}
            ></Marker> */}

        </MapContainer>
        <br />
        <DirectoryTable data={visibleData} height={400} loading={false} />

    </Box>
    )
}


const MapSearch = ({ }) => {

    const map = useMap()
    useEffect(() => {
        const provider = new OpenStreetMapProvider();

        const searchControl = new GeoSearchControl({
            provider,
            // style: "bar",
            showMarker: false,
            // showPopup: false,
            // autoClose: true,
            searchLabel: "Enter location",
            notFoundMessage: 'Sorry, that address could not be found.',
            style: 'bar',
        });
        map.addControl(searchControl);

        return () => map.removeControl(searchControl);
    }, [map])



    return null

}

const MarkerClusterComponent = ({ tableData, setVisibleData }) => {


    const map = useMapEvents({

        moveend(e) {
            // if (map.getBounds().contains([51.0456064, -114.057541])) {
            //     console.log("calgary visible")
            // } else {
            //     console.log("calgary not visible")
            // }
            updateVisibleData()
        }
    })

    useEffect(() => {
        if (!map) return;
        // Updates markers after map initially renders
        // if (map.getBounds().contains([51.0456064, -114.057541])) {
        //     console.log("calgary visible")
        // } else {
        //     console.log("calgary not visible")
        // }
        updateVisibleData()
    }, [map])

    const updateVisibleData = () => {
        setVisibleData(tableData.filter((data) => (map.getBounds().contains([data.addressCordinates[0].latitude, data.addressCordinates[0].longitude]))))
    }

    // const createClusterCustomIcon = function (cluster) {
    //     return L.divIcon({
    //       html: `<span>${cluster.getChildCount()}</span>`,
    //       className: 'marker-cluster-custom marker-cluster',
    //       iconSize: L.point(40, 40, true),
    //     });
    //   }

    return (
        <MarkerClusterGroup >
            {(tableData).map((data, index) => (
                <Marker
                    key={index}
                    position={[data.addressCordinates[0].latitude, data.addressCordinates[0].longitude]}
                    // title={data.addressCordinates[0].formattedAddress}
                    // icon={customIcon}
                ></Marker>
            ))}
        </MarkerClusterGroup>
    )
}

export default SafeApMapPopup;